'use client'

import type { ReactNode } from 'react'

import { cx } from '@/utils/cx'

interface ActionsCellProps {
  children: ReactNode
  className?: string
}

export function ActionsCell({ children, className }: ActionsCellProps) {
  // Stop the press from bubbling to the row so clicking an action doesn't trigger row navigation.
  return (
    <div
      className={cx('flex items-center justify-end gap-3 whitespace-nowrap', className)}
      data-row-no-nav
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  )
}
